import RoleToolbar from "./toolbar.js";

RoleToolbar.define();

export default RoleToolbar;
export * from './toolbar.js';

/**
 * @type {import("./toolbar-globals.js")}
 */

